// src/App.js
import React from "react";
import { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./contexts/AuthContext";
import { LookupProvider } from "./contexts/LookupContext";
import AppRoutes from "./routes/AppRoutes";

function App() {
  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: { zIndex: 9999 },
        }}
      />
      <AuthProvider>
        <LookupProvider>
          <AppRoutes />
        </LookupProvider>
      </AuthProvider>
    </>
  );
}

export default App;
